import React, { useEffect, useState } from "react";
import {
  Box,
  DialogContent,
  Grid,
  Paper,
  Typography,
  Tooltip,
} from "@mui/material";
import {
  DatePickerComponent,
  RadioButtonComponent,
} from "../../../atom";
import TextButtonComponet from "../../../atom/Buttons/TextButton";
import { useDispatch } from "react-redux";
import { Actions } from "../../../../core/modules/Actions";
import { getText, THEME_COLORS } from "../../../../core/Constant";
import _ from "lodash";
import moment from "moment";

const AdminStudentEditCourseForm = ({ onclickcancel, course, openEditCourse, stdSearchQuery }) => {
  const dispatch = useDispatch();
  const [planExpiryDate, setPlanExpiryDate] = useState();
  const [planExpiryDateError, setPlanExpiryDateError] = useState()
  const [isPlanExpiryDateValid, setPlanExpiryDateValid] = useState(false)

  const [batchMonth, setBatchMonth] = useState();
  const [batchMonthError, setBatchMonthError] = useState("")
  const [batchMonthValid, setBatchMonthValid] = useState(false)

  const [batchYear, setBatchYear] = useState();
  const [batchYearError, setBatchYearError] = useState()
  const [batchYearValid, setBatchYearValid] = useState(false) 
  
  const [selectedPlan, setSelectedPlan] = useState();
  const currentPlan = course?.prices?.find((plan)=> plan?.is_enrolled )
  const currentPlanName = currentPlan?.plan_name || ""
  const needsTooltipPlan = currentPlanName?.length > 17
  const displayedTextPlan = needsTooltipPlan
                     ? `${currentPlanName?.substring(0, 17)}...`
                     : currentPlanName;

  const courseName = course?.course?.name || "Unnamed Course";
  const needsTooltip = courseName?.length > 50;
  const displayedText = needsTooltip
    ? `${courseName?.substring(0, 50)}...`
    : courseName;

  useEffect(()=>{
   if(course && openEditCourse){
    setBatchMonth(course?.student_batch_month)
    setBatchYear(course?.student_batch_year)
    setPlanExpiryDate(course?.course_expiry_date)
    setSelectedPlan(currentPlan?.id)
    setPlanExpiryDateValid(true)
    setPlanExpiryDateError("")
    setBatchMonthError("")
    setBatchMonthValid(true)
    setBatchYearError("")
    setBatchYearValid(true)
   } else {
    setBatchMonth("")
    setBatchYear("")
    setPlanExpiryDate("")
    setSelectedPlan("")
   }
  },[course,openEditCourse])

  const handlePlanChange = (e)=>{
    const value = getText(e)
    const selectedPlan = course?.prices?.find((plan)=> plan?.id?.toString() === value?.toString() )
    setSelectedPlan(value)
    setBatchMonth(selectedPlan?.batch_month)
    setBatchYear(selectedPlan?.batch_year)
    setPlanExpiryDate(selectedPlan?.expires_at)
  }

  const handleExpiryDateChange = (date)=>{
   setPlanExpiryDateError("");
   setPlanExpiryDate(date)
   const isValid = date?.toString()?.length > 0;
   setPlanExpiryDateValid(isValid);
  }

  const handleBatchMonthChange = (date)=> {
   setBatchMonthError("")
   setBatchMonth(date)
   const isValid = date?.toString()?.length > 0;
   setBatchMonthValid(isValid);
  }

  const handleBatchYearChange = (date)=> {
    const selectedYear = moment(date).year()
    if(date){
        const newYear = Number(selectedYear);
        const currentYear = moment().year();
        const currentMonth = moment().month
        const existingMonth = Number(batchMonth);
        let updatedBatchMonth = batchMonth;
         if (existingMonth) {
          if (
            newYear === currentYear &&
            existingMonth < currentMonth
          ) {
            updatedBatchMonth = "";
          }
        }
        setBatchMonth(updatedBatchMonth)
        setBatchYear(selectedYear);
    }
   setBatchYearError("")
   setBatchYear(selectedYear)
   const isValid = date?.toString().length > 0;
   setBatchYearValid(isValid);
  }

  const onSaveEnrollment = ()=> {
   if(
    isPlanExpiryDateValid &&
    batchMonthValid && 
    batchYearValid 
   ){
     const params = {
        course_id: course?.course?.id || "",
        user_id: course?.user_id || "",
        batch_month: batchMonth || "",
        batch_year: batchYear || "",
        expires_at: planExpiryDate || "",
        course_plan_id: selectedPlan || "",
        stdSearchQuery,
      }

      dispatch(Actions.students.updateStudentEnrollment(params));
      onclickcancel()
    } else {
      if (!isPlanExpiryDateValid) {
        setPlanExpiryDateError("Please enter valid expiry date.");
      }

      if(!batchMonthValid){
        setBatchMonthError("Please enter valid month.");
      }

      if(!batchYearValid){
        setBatchYearError("Please enter valid year.");
      }
    }
  }

   const currentYear = moment().year();
   const effectiveBatchYear = batchYear
     ? Number(batchYear)
     : currentYear;
   const isCurrentYear = effectiveBatchYear === currentYear;
   const monthMinDate = isCurrentYear
     ? moment().startOf("month").toDate()
     : moment({
         year: effectiveBatchYear,
         month: 0,
         day: 1,
       })
         .startOf("month")
         .toDate();
                       
      const monthMaxDate = moment({
        year: effectiveBatchYear,
        month: 11,
        day: 1,
      })
        .endOf("month")
        .toDate();

  

  return (
    <Box p={1}>
      <DialogContent>
        <Paper
          elevation={0}
          sx={{
            p: 3,
            bgcolor: "#FCF8FF",
            borderRadius: 3,
            border: "1px solid #E7D5FF",
            mb: 4,
          }}
        >
          <Box sx={{
            width:"100%",
            display:"flex",
            flexDirection:"row",
            justifyContent:"space-between",
          }}>  
          <Box width={"15%"}>
             <Typography component={"span"} fontWeight={700} fontSize={16} mb={1}>
                Course Name
              </Typography>

              <Typography>
                {needsTooltip ? (
                  <Tooltip title={courseName} placement="top" arrow>
                    <span style={{ cursor: "pointer" }}>{displayedText}</span>
                  </Tooltip>
                ) : (
                  displayedText
                )}
              </Typography>
          </Box>
             
          
          <Box>
            <Typography component={"span"} fontWeight={700} fontSize={16} mb={1}>
                Current Plan Type
            </Typography>
              
             <Typography>
              {needsTooltipPlan ? (
                <Tooltip title={currentPlanName} placement="top" arrow>
                  <span style={{ cursor: "pointer" }}>
                    {displayedTextPlan}
                  </span>
                </Tooltip>
              ) : (
                displayedTextPlan
              )} 
             </Typography>
          </Box>
          <Box>
            <Typography fontWeight={700} fontSize={16} mb={1} component={"span"}>
                Current Batch
             </Typography>
            
             <Typography>
               { course?.student_batch_month && course?.student_batch_year ? `${moment().month(Number(course?.student_batch_month) - 1).format("MMMM")} ${course?.student_batch_year}` : ""}
             </Typography>
          </Box>
          <Box>
            <Typography fontWeight={700} fontSize={16} mb={1} component={"span"}>
                Registration Date
             </Typography>

             <Typography>{ course?.registeredDate ? moment(course?.registeredDate).format("DD-MM-YYYY") : "" }</Typography>
          </Box>
          <Box>
            <Typography fontWeight={700} fontSize={16} mb={1} component={"span"}>
                Current Expiry Date
              </Typography>

              <Typography>{course?.course_expiry_date ? moment(course?.course_expiry_date).format("DD-MM-YYYY") : "" }</Typography>
          </Box>
          </Box>
        </Paper>

        <Box>
          <Typography
               color={THEME_COLORS.gray3}
               fontWeight={700}
               fontSize={28}
               pb={1}
             >  
            Plan Type
          </Typography>

          <Grid container>
            {course?.prices?.map((plan) => {
              const planNameOp = plan?.plan_name
              const needsTooltipOp = planNameOp?.length > 14
              const displayedTextOp = needsTooltipOp
                 ? `${planNameOp?.substring(0, 14)}...`
                 : planNameOp;
              if(planNameOp){
                return (
                <Grid item xs={2}>
                  <Box display={"flex"} alignItems={"center"}>
                    <RadioButtonComponent
                      checked={selectedPlan?.toString() === plan?.id?.toString()}
                      handleChange={handlePlanChange}
                      value={plan?.id}
                    />
                    <Typography>
                      {needsTooltipOp ? (
                        <Tooltip title={planNameOp} placement="top" arrow>
                          <span style={{ cursor: "pointer" }}>
                            {displayedTextOp}
                          </span>
                        </Tooltip>
                      ) : (
                        displayedTextOp
                      )} 
                    </Typography>
                  </Box>
                </Grid>
              );
              }
            })}
          </Grid>
        </Box>

       
        <Typography variant="h5" fontWeight={700} mt={5} mb={4}>
          Edit Course Enrollment Details
        </Typography>

        <Grid container spacing={3}>
          <Grid item xs={6}>
            <Typography
               color={THEME_COLORS.gray3}
               fontWeight={700}
               fontSize={28}
               pb={1}
             >  
              Batch
              <span style={{ color: "#d06060", marginLeft: 2, fontSize:19 }}>
                *
             </span>
            </Typography>
            
            <Paper
              elevation={0}
              sx={{
                p: 2,
                bgcolor: THEME_COLORS.primaryLight,
                border: "1px solid #E7D5FF",
                borderRadius: 3,
              }}
            >
              <Grid container spacing={2}>
                <Grid item xs={6}>
                  <DatePickerComponent
                    label={"Month"}
                    containeStyle={{
                      padding: 0,
                    }}
                    customInput={
                      <input
                        style={{
                          backgroundColor: THEME_COLORS.white,
                          border: `1px solid ${THEME_COLORS.inputBorderColor}`,
                        }}
                      />
                    }
                    dateFormat="MMMM"
                    showMonthYearPicker
                    minDate={monthMinDate}                                                
                    maxDate={monthMaxDate}
                    placeholderText="Month"
                    selected={
                      batchMonth
                      ? moment({
                          year: Number(batchYear) || moment().year(),
                          month: Number(batchMonth) - 1,
                          day: 1,
                        }).toDate()
                      : null
                    }
                    onChange={(date) => {
                      handleBatchMonthChange( date ? moment(date).month() + 1 : "")
                    }}
                    isError={Boolean(batchMonthError)}
                    error={batchMonthError}
                  />
                </Grid>

                <Grid item xs={6}>
                  <DatePickerComponent
                    label={"Year"}
                    containeStyle={{
                      padding: 0,
                    }}
                    customInput={
                      <input
                        style={{
                          backgroundColor: THEME_COLORS.white,
                          border: `1px solid ${THEME_COLORS.inputBorderColor}`,
                        }}
                      />
                    }
                    showYearPicker
                    minDate={moment().startOf("year").toDate()}
                    placeholderText="Year"
                    selected={
                      batchYear
                        ? moment()
                            .year(Number(batchYear))
                            .startOf("year")
                            .toDate()
                        : null
                    }
                    dateFormat="yyyy"
                    onChange={(date) => {
                      handleBatchYearChange(date)
                    }}
                    isError={Boolean(batchYearError)}
                    error={batchYearError}
                  />
                </Grid>
              </Grid>
            </Paper>
          </Grid>

          <Grid item xs={6}>
            <Typography
               color={THEME_COLORS.gray3}
               fontWeight={700}
               fontSize={28}
               pb={1}
             >  
              Expiry Date
              <span style={{ color: "#d06060", marginLeft: 2, fontSize:19 }}>
                *
             </span>
            </Typography>
            <DatePickerComponent
              containeStyle={{
                padding: 0,
              }}
              dateFormat="dd/MM/yyyy"
              minDate={moment().startOf("day").toDate()}
              selected={
                planExpiryDate &&
                moment(planExpiryDate, "YYYY-MM-DD", true).isValid()
                  ? moment(planExpiryDate, "YYYY-MM-DD").toDate()
                  : null
              }
              onChange={(date) => {
                handleExpiryDateChange(date ? moment(date).format("YYYY-MM-DD") : "")
              }}
              isError={Boolean(planExpiryDateError)}
              error={planExpiryDateError}
            />
          </Grid>
        </Grid>

        <Grid
          mt={5}
          rowGap={4}
          container
          direction={"row"}
          justifyContent={"flex-end"}
        >
          <Grid item xs={12} sm={2} mr={2}>
            <TextButtonComponet
              text="Cancel"
              classStyle="btn btn-secondary"
              onButtonClick={onclickcancel}
            />
          </Grid>
          <Grid item xs={12} sm={2}>
            <TextButtonComponet text={"Save Enrollment"} onButtonClick={onSaveEnrollment} />
          </Grid>
        </Grid>
      </DialogContent>
    </Box>
  );
};

export default AdminStudentEditCourseForm;
